
<template>
    <div class="social">
        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="fb_link"
            f_type="fb_link"
            @update_categ="change_atr"
            :f_title="__t('FB_LINK')"
            :f_val=social.fb_link>
        </info_field>


        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="insta_link"
            f_type="insta_link"
            @update_categ="change_atr"
            :f_title="__t('INSTA_LINK')"
            :f_val=social.insta_link>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="youtube_link"
            f_type="youtube_link"
            @update_categ="change_atr"
            :f_title="__t('YOUTUBE_LINK')"
            :f_val=social.youtube_link>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="tiktok_link"
            f_type="tiktok_link"
            @update_categ="change_atr"
            :f_title="__t('TIKTOK_LINK')"
            :f_val=social.tiktok_link>
        </info_field>


    </div>
</template>


<script>
import info_field from "../../../../../sys/info_field";
export default {
    name: "pwa_social",
    components : {
        info_field,
    },
    props : {
        pwa : {
            type:Object
        }
    },

    methods : {
        change_atr(atr_name,atr_val) {
            if(this.pwa.social.hasOwnProperty(atr_name)) {
                this.pwa.social[atr_name] = atr_val;
            }
        }
    },

    computed : {

        social() {
            return this.pwa.social;
        },

        is_disabled() {
            return false;
        },
    }
}
</script>

<style scoped>

</style>
